
import { EntityService } from '@/services/entity.service'
import Vue from 'vue'
import New from './New.vue'
import Edit from './Edit.vue'

const entityService = new EntityService()

export default Vue.extend({
  name: 'UsersList',
  components: {
    New,
    Edit
  },
  data: () => ({
    entity: 'projects',
    search: '',
    listData: [],
    headers: [
      {
        text: 'Código',
        value: 'code'
      },
      {
        text: 'Nombre del proyecto',
        value: 'name'
      },
      {
        text: 'Palabras Clave',
        value: 'keywords'
      },
      {
        text: '',
        value: 'actions',
        align: 'right'
      }
    ],
    showModalNew: false,
    showModalEdit: false,
    editEntity: {},
    colors: ['#13DEB9FF', '#49BEFFFF', 'rgb(93, 135, 255)', 'rgb(250, 137, 107)']
  }),
  async created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.listData = await entityService.getList(this.entity)
    },
    editEntityAction (entity: object) {
      this.editEntity = entity
      this.showModalEdit = true
    },
    getRandomColor () {
      return this.colors[Math.floor(Math.random() * this.colors.length)]
    },
    async syncProjects () {
      const response = await entityService.getList('m3/sync-projects')
      alert(response.length + ' Proyectos Sincronizados')
    }
  },
  watch: {
    showModalNew (value) {
      if (!value) this.loadData()
    },
    showModalEdit (value) {
      if (!value) this.loadData()
    }
  }
})
